import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';

import { ImageFromField } from '@uncinc/react-drupal-core';

import {
  WysiwygField,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Button } from '../../../components';
import { prependApiURLToImageStyles } from '../../../helpers/prependApiURL';

import {
  SCREEN_MEDIUM,
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  SCREEN_WIDE,
} from '../../../config/constants';

import './style.scss';

const ParagraphTextImage = ({ entity, className }) => {
  const classes = classNames('Paragraph ParagraphTextImage', className);
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_text', 0, 'processed']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const link = entity.getIn(['field_link', 0], Immutable.Map());
  const href = link.get('alias') ? link.get('alias') : link.get('uri');
  const imageField = entity.getIn(['field_image', 0], Immutable.Map());

  return (
    <div className={classes}>
      <Container>
        <div className="row">
          {imageField.get('styles') && (
            <div className="col-md-6 col-12">
              <div className="ParagraphTextImage__image">
                <ImageFromField
                  className="ParagraphImage__img"
                  field={prependApiURLToImageStyles(imageField)}
                  imageStyles={Immutable.Map({
                    [SCREEN_MOBILE]: 'crop_paragraph_text_image_xs',
                    [SCREEN_MEDIUM]: 'crop_paragraph_text_image_sm',
                    [SCREEN_TABLET]: 'crop_paragraph_text_image_md',
                    [SCREEN_NORMAL]: 'crop_paragraph_text_image_lg',
                    [SCREEN_WIDE]: 'crop_paragraph_text_image_xl',
                  })}
                />
              </div>
            </div>
          )}
          <div className="col-md-5 col-12 offset-md-1">
            <div className="ParagraphTextImage__content">
              <h2 className="ParagraphTextImage__content__title">{title}</h2>
              <WysiwygField
                property="schema:text"
                className="ParagraphTextImage__content__text"
                html={body}
              />
              {href && linkTitle && <Button key={href} href={href}>{linkTitle}</Button>}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphTextImage;
